import { Controller } from "@hotwired/stimulus";
import { leave } from "el-transition";

export default class extends Controller {
  static values = {
    countdown: Number,
  };

  commence() {
    this.element
      .querySelectorAll("input, textarea, select")
      .forEach((field) => (field.disabled = true));

    setTimeout(
      () => {
        this.element.remove();
      },
      this.hasCountdownValue ? this.countdownValue : 250,
    );

    leave(this.element);
  }

  commenceOnBlankBackspace(event) {
    if (event.key === "Backspace") this.commenceIfBlank(event);
  }

  commenceIfBlank(event) {
    if (this.#hasEntries) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    const previousField = this.element.previousElementSibling?.querySelector(
      "input:not([type=hidden]), textarea, button",
    );
    this.commence();
    previousField?.focus();
    previousField?.setSelectionRange?.(
      previousField.value.length,
      previousField.value.length,
    );
  }

  get #hasEntries() {
    return [
      ...this.element.querySelectorAll(
        "input[type=text]:enabled, textarea:enabled",
      ),
    ].some((field) => field.value !== "" && field.checkVisibility());
  }
}
